<template>
  <div class="bg-gray-800 p-8">
      <div class="flex justify-around items-center space-x-8 text-white font-semibold">
        <h2 class="text-base xl:text-xl">Amazing things happen to your business</h2>
        <button class="border-2 bg-black text-white text-sm px-4 py-2 2xl:py-3 2xl:px-8 rounded">Contact Us</button>
      </div>
  </div>
</template>

<script>
export default {
    name:'ContactUs'
}
</script>

<style>

</style>